// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//


import { ApiParameter, post } from "@insite/client-framework/Services/ApiService";

const url = "/api/sc/rfq/submit";

export interface manufacturerItem {
    manufacturerItemNumber: string,
    manufacturerName: string;
    itemDescription: string;
}

export interface RfqFormApiParameter extends ApiParameter {
    firstName: string;
    lastName: string;
    phoneNumber: string;
    email: string;
    notes?: string;
    manufacturerItems: manufacturerItem[];
}

export function submitForm(parameter: RfqFormApiParameter) {
    return post(`${url}`, parameter);
}